import { render, staticRenderFns } from "./GlazingOption.vue?vue&type=template&id=5248817e&lang=pug"
import script from "./GlazingOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlazingOption.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports